<template>
    <div class="ff-divider"></div>
</template>

<script>
export default {
    name: 'ff-divider'
}
</script>

<style lang="scss" scoped>
.ff-divider {
    width: 100%;
    height: 1px;
    background-color: $ff-grey-200;
    margin-top: 12px;
    margin-bottom: 12px;
}
</style>
